import { render, staticRenderFns } from "./currency-field.vue?vue&type=template&id=773cfa37"
import script from "./currency-field.vue?vue&type=script&lang=ts"
export * from "./currency-field.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports